import { ArrowRightToBracket } from '@styled-icons/fa-solid';
import { Link } from 'react-router-dom';
import { ShowIf } from '../../Security/security';

const DeclarationsActionsButton = ({ id, portalId, loadId }) => {
  let actionsLink = `/DeclarationsActions/${id}`;
  if (portalId && loadId) {
    actionsLink = `/DeclarationsActions/${id}/${portalId}/${loadId}`;
  }

  return (
    <div>
      <ShowIf
        or={[
          { department: 'OPS', role: 'SUPERUSER' },
          { department: 'QA', role: 'SUPERUSER' },
        ]}
      >
        <Link to={actionsLink}>
          <ArrowRightToBracket className="text-secondary" width="1rem" height="1rem" />
        </Link>
      </ShowIf>
    </div>
  );
};

export default DeclarationsActionsButton;
